import TheOdds from "./TheOdds";

export default TheOdds;
